module.exports = __webpack_public_path__ + "resources/images/rabobank-b9a4ce57807832743d04eca1780cf5cc-cache.png";